import React from 'react';
import { ToggleButtonGroup, ToggleButton, Typography, Button, FormControl, MenuItem, Select, IconButton } from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import MenuIcon from '@mui/icons-material/Menu';
import { useGeminiLanguage } from 'canvas/hooks/useGeminiLanguage';
import { getCanvasMessages } from 'canvas/utils/canvasI18n';
import BoardGoalEditor from 'canvas/components/BoardGoalEditor';
import BoardSettingsPanel from 'canvas/components/BoardSettingsPanel';

const LibraryToolbar = ({
  title,
  viewMode,
  onViewModeChange,
  boardName,
  pinCount = 0,
  showMenuButton = false,
  onOpenSidebar,
  personName,
  isOwner = false,
}) => {
  const canCanvas = Boolean(boardName);
  const showCanvasCta = canCanvas && pinCount >= 3 && viewMode !== 'canvas';
  const showCanvasGoal = viewMode === 'canvas' && Boolean(boardName);
  const { geminiLanguage, setGeminiLanguage, GEMINI_LANGUAGE_OPTIONS } = useGeminiLanguage();
  const messages = getCanvasMessages(geminiLanguage);

  return (
    <div className="library-toolbar">
      <div className="library-toolbar-title-row">
        {showMenuButton ? (
          <IconButton
            className="library-mobile-menu-btn"
            aria-label="Open navigation"
            onClick={onOpenSidebar}
            size="small"
          >
            <MenuIcon />
          </IconButton>
        ) : null}
        <Typography className="library-toolbar-title" component="h1">
          {title}
        </Typography>
        {showCanvasGoal ? (
          <div className="library-toolbar-canvas-goal">
            <BoardGoalEditor key={boardName} />
          </div>
        ) : null}
        {viewMode === 'canvas' && boardName ? (
          <BoardSettingsPanel
            personName={personName}
            hashtag={boardName}
            isOwner={isOwner}
          />
        ) : null}
        {viewMode === 'canvas' ? (
          <FormControl size="small" className="library-toolbar-language-select-wrap">
            <Select
              value={geminiLanguage}
              onChange={event => setGeminiLanguage(event.target.value)}
              displayEmpty
              className="library-toolbar-language-select"
              inputProps={{ 'aria-label': messages.languageSelectAria }}
            >
              {GEMINI_LANGUAGE_OPTIONS.map(option => (
                <MenuItem key={option.code} value={option.code}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : null}
      </div>
      <div className="library-toolbar-actions">
        {showCanvasCta ? (
          <Button size="small" variant="outlined" onClick={() => onViewModeChange('canvas')} sx={{ mr: 1 }}>
            {messages.arrangeOnBoard}
          </Button>
        ) : null}
        <ToggleButtonGroup
          size="small"
          exclusive
          value={viewMode}
          onChange={(_, value) => {
            if (value) onViewModeChange(value);
          }}
          aria-label={messages.viewModeAria}
        >
          <ToggleButton value="gallery" aria-label={messages.galleryViewAria}>
            <ViewModuleIcon fontSize="small" />
          </ToggleButton>
          <ToggleButton value="canvas" aria-label={messages.canvasViewAria} disabled={!canCanvas}>
            <DashboardCustomizeIcon fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
    </div>
  );
};

export default LibraryToolbar;
